@if (product()) {
    <div class="content-container p-32:b md:p-48:b lg:p-64:b">
        <h1 class="c:blue-700 p-48:t md:p-64:t lg:p-96:t m-0">{{ product().title }}</h1>
        <div
            [innerHTML]="product().presentation.description"
            class="m-12:t md:m-16:t lg:m-24:t product-description"
        ></div>
        <ul class="check m-24:b">
            @for (point of product().presentation.bulletPoints; track $index) {
                <li [innerHTML]="point"></li>
            }
        </ul>
        <form
            [formGroup]="form"
            (submit)="submit()"
        >
            <!-- #region device type selection -->
            <h3 class="m-24:t md:m-32:t lg:m-48:t c:blue-700">Wähle das Gerät, das du versichern möchtest*:</h3>
            <div class="device-card-container">
                @for (device of devices; track device.displayName) {
                    <div class="device-card-wrapper">
                        <app-electronics-b2c-device-card
                            [device]="device"
                            [selected]="selectedDevice?.name"
                            formControlName="type"
                        />
                    </div>
                }
            </div>
            <!-- #endregion -->

            <!-- #region device value input -->
            @if (selectedDevice) {
                <h3
                    id="purchasing-price-label"
                    class="m-24:t md:m-32:t lg:m-48:t c:blue-700"
                >
                    Kaufpreis {{ selectedDevice.displayNameDative }}*:
                </h3>
                <div class="grid-container m-24:b">
                    <div class="g-12 md:g-6">
                        <div
                            class="form-control with-info-tooltip"
                            #priceContainer
                        >
                            <input
                                type="text"
                                appPriceInput
                                appSuspendEnter
                                outputType="string"
                                id="price"
                                formControlName="value"
                                placeholder="Kaufpreis"
                                [ctrlErrorMessage]="valueErrorMessage"
                                required
                                aria-labelledby="purchasing-price-label"
                            />
                            <span class="fit-label c:headline fw:semibold">€</span>
                            <app-info-tooltip
                                heading="Unsubventionierter Kaufpreis"
                                text="Der unsubventionierte Kaufpreis ist der zum Kaufzeitpunkt gültige
                                Marktpreis. Wenn das Gerät z.B. im Rahmen eines Mobil&shy;funkvertrags
                                oder gebraucht erworben wurde, gib bitte den tatsächlichen Wert
                                des Gerätes zum Zeitpunkt des Kaufs an."
                            />
                        </div>
                        <app-required-info />
                    </div>
                </div>
            }
            <!-- #endregion -->

            <!-- #region price and variant switches -->
            @if (price() !== 0) {
                <section class="bg:grey-5 p-24:v md:p-32:v lg:p-64:v">
                    <div class="content-container">
                        <div class="grid-container">
                            <div class="g-12 sm:g-6">
                                <app-variants-fieldset
                                    [hasDeductible]="hasDeductible()"
                                    [hasMonthlySettlementPeriod]="hasMonthlySettlementPeriod()"
                                    [hasTheftCoverage]="hasTheftCoverage()"
                                    [boughtInLastTwoWeeks]="boughtInLastTwoWeeks()"
                                    (toggleDeductible)="toggleDeductible($event)"
                                    (toggleSettlementPeriod)="toggleSettlementPeriod($event)"
                                    (toggleTheftCoverage)="toggleTheftCoverage($event)"
                                    (toggleBoughtInLastTwoWeeks)="toggleBoughtInLastTwoWeeks($event)"
                                />
                            </div>
                            <!-- #endregion -->

                            <!-- #region price -->
                            @if (price() !== 0) {
                                <div class="g-12 sm:g-6 bg:grey-5">
                                    <app-price-display-card
                                        class="lg:g-4"
                                        [bannerText]="product().title"
                                        [price]="price() === 0 ? undefined : price()"
                                        [settlementPeriod]="hasMonthlySettlementPeriod() ? 'month' : 'year'"
                                        [taxInfo]="product().orderConfig.taxInfo"
                                        buttonText="Diesen Tarif wählen"
                                        [buttonDisabled]="form.invalid"
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </section>
            }
            <!-- #endregion -->

            <!-- #region benefits table -->
            <h3 class="m-24:t md:m-32:t lg:m-48:t c:blue-700">Das leistet die {{ product().title }}</h3>
            <app-collapsible-table [tableData]="damagesTable" />
            <!-- #endregion -->

            <div class="grid-container -end m-24:t md:m-32:t lg:m-48:t">
                <button
                    type="submit"
                    class="g-12 sm:g-auto next"
                    [disabled]="form.invalid"
                >
                    Diesen Tarif wählen
                </button>
            </div>

            <!-- #region legal documents -->
            <p class="m-12:t md:m-16:t lg:m-24:t">
                Hier kannst du das
                <a
                    [href]="'/assets/documents/' + product().presentation.docIPIDUrl"
                    target="_blank"
                    rel="noreferrer noopener"
                    title="Informationsblatt zu Versicherungsprodukten (PDF)"
                    >Informationsblatt zu Versicherungsprodukten (PDF)</a
                >, die
                <a
                    [href]="'/assets/documents/' + product().presentation.docAVBUrl"
                    target="_blank"
                    rel="noreferrer noopener"
                    title="Allgemeine Versicherungsbedingungen (PDF)"
                    >Allgemeinen Versicherungsbedingungen (PDF)</a
                >, das
                <a
                    [href]="'/assets/documents/' + product().presentation.docAnzeigepflichtUrl"
                    target="_blank"
                    rel="noreferrer noopener"
                    title="Informationsblatt zu Obliegenheiten und Anzeigepflicht (PDF)"
                    >Informationsblatt zu Obliegenheiten und Anzeigepflicht (PDF)</a
                >
                und die
                <a
                    [href]="'/assets/documents/' + product().presentation.docAddInfoUrl"
                    target="_blank"
                    rel="noreferrer noopener"
                    title="Weitere Kundeninformationen (PDF)"
                    >weiteren Kundeninformationen (PDF)</a
                >
                einsehen.
            </p>
            <!-- #endregion -->

            <!-- #region faq -->
            <h3 class="m-24:t md:m-32:t lg:m-48:t c:blue-700">FAQ</h3>
            <p class="l m-24:b md:m-32:b lg:m-48:b">
                Hier findest du Antworten auf die häufigsten Fragen zu allen Themen rund um unsere
                Versicherungsangebote.
            </p>
            <app-faq-electronics-b2c />
            <!-- #endregion -->

            <div class="grid-container -end m-12:t md:m-16:t lg:m-24:t">
                <button
                    type="submit"
                    class="g-12 sm:g-auto next"
                    [disabled]="form.invalid"
                >
                    Diesen Tarif wählen
                </button>
            </div>
        </form>
    </div>
}
